export default "__VITE_ASSET__c0fd75a5__"